var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKeyGradient = function SvgKeyGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#keyGradient_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#keyGradient_svg__b)",
    fillRule: "evenodd",
    d: "M9.75 8.25a6 6 0 1 1 4.097 5.692 1.13 1.13 0 0 0-1.152.272L11.16 15.75H9.375c-.621 0-1.125.504-1.125 1.125v1.784l-.091.091H6.375c-.621 0-1.125.504-1.125 1.125v1.784l-.091.091H2.625a.375.375 0 0 1-.375-.375v-2.534l7.536-7.536c.302-.302.407-.748.272-1.152A6 6 0 0 1 9.75 8.25m6-8.25a8.25 8.25 0 0 0-8.022 10.181L.33 17.58c-.211.21-.33.497-.33.795v3A2.625 2.625 0 0 0 2.625 24h3c.298 0 .585-.119.795-.33l.75-.75c.211-.21.33-.497.33-.795V21h1.125c.298 0 .585-.119.796-.33l.75-.75c.21-.21.329-.497.329-.795V18h1.125c.298 0 .585-.119.796-.33l1.398-1.398A8.25 8.25 0 1 0 15.75 0m.75 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "keyGradient_svg__b",
    x1: 12,
    x2: 12,
    y1: 0,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#389CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B00DE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "keyGradient_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgKeyGradient;